

import React, { forwardRef } from 'react';
import cx from 'classnames';

import { Text } from '../../../../../../../ui-kit';
import CommentComponent from '../../../../Comment';
import '../styles/_comment-group.scss';




























function Group({
  commentsWithMetadata,
  group: { comments, title },
  getCommentTitle,
  getSceneLabel,
  isGroupSelected,
  onSelectComment,
  selectedCommentId,
  commentIds,
  isReadOnlyMode,
  showReplyCommentForm,
  onInputFocus,
  isVideoCompleted,
  isV2Design,
  commentIdToEdit,
  toggleEditMode,
  hideTimestamp,
  hideVisibility,
  id,
  isStoryboard,
  showShotName,
  shotsMap
}, ref) {
  return (
    <div
      className={cx('comment-group', {
        'comment-group--v2': isV2Design
      })}
      {...ref && { ref }}
      id={id}>

      {title ? <Text highlighted>{title}</Text> : null}
      {
      comments.map((comment) => {
        const { commentId } = comment;
        const commentIndex = commentIds.indexOf(commentId);
        const commentWithMetadata = commentsWithMetadata.find(
          (commentWithMeta) => commentWithMeta.commentId === commentId);

        const commentOrder = isVideoCompleted ?
        commentIndex + 1 :
        commentWithMetadata && commentWithMetadata.number;

        return (
          <CommentComponent
            isV2Design={isV2Design}
            key={commentId}
            commentIndex={commentIndex}
            comment={comment}
            commentOrderByTimeline={commentOrder}
            getCommentTitle={getCommentTitle}
            getSceneLabel={getSceneLabel}
            isGroupSelected={isGroupSelected}
            onSelectComment={onSelectComment}
            isCommentSelected={selectedCommentId === commentId}
            isReadOnlyMode={isReadOnlyMode}
            showReplyCommentForm={showReplyCommentForm}
            onInputFocus={onInputFocus}
            commentIdToEdit={commentIdToEdit}
            toggleEditMode={toggleEditMode}
            hideTimestamp={hideTimestamp}
            hideVisibility={hideVisibility}
            isStoryboard={isStoryboard}
            showShotName={showShotName}
            shotsMap={shotsMap} />);


      })}

    </div>);

}

export default forwardRef(Group);